/** @jsxImportSource @emotion/react */
import { useGetProgressBarStyles } from "./index.styles";

const ProgressBar = ({ progress = 0, progress11 = 1000 }) => {
  const progressBar = progress !== 0 ? Number(progress) / 10 : 0;
  const progressValue = progressBar > 100 ? 100 : progressBar;
  const styles = useGetProgressBarStyles({ progressBar: progressValue });

  return (
    <div css={styles.container}>
      <div css={styles.track}>
        <div css={styles.fill} />
        <div css={styles.shimmer} />
        {/* Milestone markers */}
        {[25, 50, 75].map((mark) => (
          <div
            key={mark}
            css={[
              styles.milestone,
              progressValue >= mark && styles.milestoneReached,
            ]}
            style={{ left: `${mark}%` }}
          />
        ))}
      </div>
      <div css={styles.labels}>
        <span css={styles.currentPoints}>{progress} pts</span>
        <span css={styles.maxPoints}>{progress11} Points</span>
      </div>
    </div>
  );
};

export default ProgressBar;
